export default __webpack_public_path__ + "static/media/shape-star.6e4ec36d.PNG";